import { 
  Notification, 
  NotificationResponse, 
  NotificationType,
  SocketConnectionStatus 
} from './notification';

// 병원 포털 전용 알림 타입 확장
export enum HospitalNotificationType {
  // 기존 타입들 포함
  APPLICATION_STATUS_CHANGED = 'APPLICATION_STATUS_CHANGED',
  INTERVIEW_SCHEDULED = 'INTERVIEW_SCHEDULED',
  INTERVIEW_REMINDER = 'INTERVIEW_REMINDER',
  INTERVIEW_CANCELLED = 'INTERVIEW_CANCELLED',
  HIRING_CONFIRMED = 'HIRING_CONFIRMED',
  SHIFT_ASSIGNED = 'SHIFT_ASSIGNED',
  SHIFT_REMINDER = 'SHIFT_REMINDER',
  SHIFT_CANCELLED = 'SHIFT_CANCELLED',
  PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
  SYSTEM_ANNOUNCEMENT = 'SYSTEM_ANNOUNCEMENT',
  
  // 병원 관리자 전용 알림 타입
  NURSE_APPLICATION_RECEIVED = 'NURSE_APPLICATION_RECEIVED',
  NURSE_HIRED = 'NURSE_HIRED',
  SHIFT_COVERAGE_REQUEST = 'SHIFT_COVERAGE_REQUEST',
  URGENT_STAFF_NEEDED = 'URGENT_STAFF_NEEDED',
  DEPARTMENT_ALERT = 'DEPARTMENT_ALERT',
  COMPLIANCE_ALERT = 'COMPLIANCE_ALERT',
  STAFF_SHORTAGE_WARNING = 'STAFF_SHORTAGE_WARNING'
}

// 알림 우선순위
export enum NotificationPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent'
}

// 병원 부서 타입
export enum HospitalDepartment {
  ICU = 'ICU',
  ER = 'ER',
  SURGERY = 'Surgery',
  PEDIATRICS = 'Pediatrics',
  MATERNITY = 'Maternity',
  ONCOLOGY = 'Oncology',
  CARDIOLOGY = 'Cardiology',
  GENERAL = 'General'
}// 병원 포털 확장 알림 인터페이스
export interface HospitalNotification extends Notification {
  priority?: NotificationPriority;
  department?: HospitalDepartment;
  category: 'application' | 'shift' | 'staff' | 'compliance' | 'system';
  actionRequired?: boolean;
  expiresAt?: string;
}

// 알림 필터 타입
export interface NotificationFilter {
  types: HospitalNotificationType[];
  departments: HospitalDepartment[];
  priorities: NotificationPriority[];
  categories: string[];
  showUnreadOnly: boolean;
  dateRange?: {
    start: string;
    end: string;
  };
}

// 대시보드 통계 타입
export interface DashboardNotificationStats {
  total: number;
  unread: number;
  urgent: number;
  byCategory: {
    application: number;
    shift: number;
    staff: number;
    compliance: number;
    system: number;
  };
  byDepartment: Record<HospitalDepartment, number>;
  byPriority: Record<NotificationPriority, number>;
}

// 병원 포털 알림 응답 타입
export interface HospitalNotificationResponse extends NotificationResponse {
  notifications: HospitalNotification[];
  stats: DashboardNotificationStats;
}

// Context 상태 타입
export interface NotificationContextState {
  notifications: HospitalNotification[];
  filteredNotifications: HospitalNotification[];
  stats: DashboardNotificationStats;
  filter: NotificationFilter;
  isLoading: boolean;
  error: string | null;
  connectionStatus: SocketConnectionStatus;
}

// Context 액션 타입
export interface NotificationContextActions {
  refreshNotifications: () => Promise<void>;
  markAsRead: (id: string) => Promise<void>;
  markAllAsRead: () => Promise<void>;
  setFilter: (filter: Partial<NotificationFilter>) => void;
  connectSocket: () => Promise<void>;
  disconnectSocket: () => void;
}

// 병원 포털 전용 알림 콜백 타입
export type NotificationCallback = (notification: HospitalNotification) => void;